import React, { useEffect, useState } from "react";
import Tiles from "./Tiles";
import Dialog from "../Dialog/Dialog";

export default function Page({ connection, toast }) {
    const [preview, setPreview] = useState(false);
    const [tiles, setTiles] = useState();
    useEffect(() => {
        connection
            .get_all_tiles()
            .then((res) => {
                setTiles(res.data);
            })
            .catch((res) => {
                toast(
                    "خطا در دریافت اطلاعات",
                    "خطا در دریافت موزایک ها",
                    " danger "
                );
            });
    }, []);

    const onChange = (structure) => {
        setTiles(structure);
    };

    const save = async () => {
        try {
            let _tiles = { ...tiles };
            let uploadables = [];
            let getUploadables = (t) => {
                t.file && uploadables.push(t.file);
                if (t.children?.length > 0) {
                    t.children.forEach((c) => {
                        getUploadables(c);
                    });
                }
            };

            getUploadables(_tiles);
            if (uploadables.length > 0) {
                let uploaded = await uploadFiles(uploadables);
                if (uploaded?.length > 0) {
                    let replaceUploadeds = (t) => {
                        if (t.file) {
                            let ufIndex = uploaded.findIndex(
                                (u) => u.name === t.file.name
                            );

                            if (ufIndex > -1) {
                                t.media = uploaded[ufIndex].url;
                                delete t.file;
                                uploaded.splice(ufIndex, 1);
                            }
                        }
                        if (t.children?.length > 0) {
                            t.children.forEach((c) => {
                                replaceUploadeds(c);
                            });
                        }
                    };
                    replaceUploadeds(_tiles);
                }
            }
            setTiles(_tiles);

            await connection.save_tiles(tiles);
            toast("ذخیره", "ذخیره شد", " confirm");
        } catch (err) {
            toast(
                "خطا در ذخیره سازی",
                `ذخیره با خطا مواجه شد لطفا مجددا تلاش کنید\n
                                                خطا:\n
                                                ${err.code}\n
                                                ${err.name}\n
                                                ${err.message}\n
                                                `,
                " danger"
            );
        }
    };

    const uploadFiles = (files) => {
        return new Promise((resolve, reject) => {
            if (files.length === 0) resolve([]);
            toast(
                "آپلود",
                "در حال آپلود فایل ها لطفا منتظر بمانید ...",
                " info"
            );
            connection
                .upload(files, (results, reqs) => {})
                .then((results) => {
                    toast(
                        "آپلود",
                        "تمام فایل ها با موفقیت آپلود شدند",
                        " confirm"
                    );
                    resolve(results);
                })
                .catch((err) => {
                    toast(
                        "خطا در آپلود فایل ها",
                        `آپلود با خطا مواجه شد لطفا مجددا تلاش کنید\n
                                                خطا:\n
                                                ${err.code}\n
                                                ${err.name}\n
                                                ${err.message}\n
                                                `,
                        " danger"
                    );
                    reject(err);
                });
        });
    };

    return (
        <div className='w-full h-full flex flex-col gap-2'>
            <div className='btn btn-success text-white text-lg' onClick={save}>
                ذخیره
            </div>

            <div
                className='btn btn-info text-white text-lg'
                onClick={() => {
                    setPreview(!preview);
                }}
            >
                {preview ? "حالت ویرایش" : "حالت پیش نمایش"}
            </div>

            <Tiles
                preview={preview}
                structure={tiles}
                root={true}
                editMode={true}
                onChange={onChange}
            />
        </div>
    );
}
